import { connect } from 'react-redux'
import View from './MainCategories'

const mapStateToProps = state => ({
  locale: state.router.locale,
  isHomePage: state.router.activeRoute.name === 'homepage',
  allCategories: state.categories.categories,
})

const MainCategories = connect(mapStateToProps)(View)

export default MainCategories
